@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.body {
  padding: @space-12;
  gap: @space-12;
  background: @grey-200;
  display: flex;
  flex-direction: column;
}

.recommendation-actions {
  display: flex;
  gap: @space-4;
}

.save-message > * {
  display: inline-block;
}

.button-wrapper {
  > *,
  button {
    width: 100%;
  }
}

.sparkly-header {
  justify-content: space-between;
  align-items: flex-start;
  gap: @space-16;
  padding: @space-16;
  flex-wrap: nowrap;
  background: linear-gradient(to right, var(--blue-BFDFFE), var(--purple-cab1ff), var(--red-F8DEDE));

  .close svg {
    fill: var(--grey-900);
  }
}

.subheader {
  align-items: center;
}

.sparkle-icon {
  color: var(--blue-524CFF);
  width: 0.875rem;
  height: 0.875rem;
  margin-right: @space-8;

  > svg {
    width: 100%;
    height: 100%;
  }
}
